'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var nthHookContextPage = require('@narvar/nth-hook-context-page');
var nthHookGlobalSettings = require('@narvar/nth-hook-global-settings');
var nthHookGrowthbook = require('@narvar/nth-hook-growthbook');
var nthHookLoma = require('@narvar/nth-hook-loma');
var nthHookSettings = require('@narvar/nth-hook-settings');

const useConsumerPreferences = () => {
  const {
    state: {
      trackingNumbers,
      orderNumbers,
      retailerMoniker,
      carrier
    }
  } = nthHookContextPage.usePageContext();
  const {
    notificationCenter
  } = nthHookSettings.useSettings();
  const {
    loading: globalSettingsLoading
  } = nthHookGlobalSettings.useGlobalSettingsX();
  const {
    enabled: sublimeDeliveryNotifiationsEnabled
  } = nthHookGrowthbook.useIsTrackFeatureOn('sublime-delivery-notifications');
  const {
    enabled: trackOnlyOptinEnabled
  } = nthHookGrowthbook.useIsTrackFeatureOn('track-only-optin');

  // Remove this check once CPREF + Marketing Opt-in is enabled
  // Also remove skip from tests in packages/nth-pack-notification-center/__tests__/cprefMarketingNotificationCenter.spec.tsx
  // to re-enable tests
  const {
    marketingOptInEnabled
  } = notificationCenter ?? {};
  const orderNumber = orderNumbers?.[0];
  const trackingNumber = trackingNumbers?.[0];
  const skip = globalSettingsLoading || sublimeDeliveryNotifiationsEnabled === false;
  const {
    data: getUserPrefsNotificationPreferencesEligibilityData
  } = nthHookLoma.useGetUserPrefsNotificationPreferencesEligibilityQuery({
    skip,
    variables: {
      retailerMoniker,
      carrier,
      orderNumber,
      trackingNumber
    }
  });
  const notificationPreferencesEligible = getUserPrefsNotificationPreferencesEligibilityData?.getUserPrefsNotificationPreferencesEligibility?.eligible ?? false;
  const orderNumberOptin = !!orderNumber && notificationPreferencesEligible;
  const trackOnlyOptin = trackOnlyOptinEnabled && !!trackingNumber && !!carrier;
  const optinEnabled = (orderNumberOptin || trackOnlyOptin) && sublimeDeliveryNotifiationsEnabled && !marketingOptInEnabled;
  return {
    optinEnabled
  };
};

exports.useConsumerPreferences = useConsumerPreferences;
